/** Returns only the props of `next` whose value differs (by ===) from `original`. */
export const diffChangedSettings = (
  original: Record<string, unknown>,
  next: Record<string, unknown>,
): Record<string, unknown> => {
  const changed: Record<string, unknown> = {};
  for (const [prop, value] of Object.entries(next)) {
    if (value !== (original ?? {})[prop]) changed[prop] = value;
  }
  return changed;
};
